/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The template engine
 */
export const UpdatePromptTemplateFormEngine = {
  Mustache: "mustache",
} as const;
/**
 * The template engine
 */
export type UpdatePromptTemplateFormEngine = ClosedEnum<
  typeof UpdatePromptTemplateFormEngine
>;

/**
 * The kind of prompt the template is used for
 */
export const UpdatePromptTemplateFormKind = {
  Prompt: "prompt",
  HigherOrderTool: "higher_order_tool",
} as const;
/**
 * The kind of prompt the template is used for
 */
export type UpdatePromptTemplateFormKind = ClosedEnum<
  typeof UpdatePromptTemplateFormKind
>;

export type UpdatePromptTemplateForm = {
  /**
   * The JSON Schema defining the placeholders found in the prompt template
   */
  arguments?: string | undefined;
  /**
   * The description of the prompt template
   */
  description?: string | undefined;
  /**
   * The template engine
   */
  engine?: UpdatePromptTemplateFormEngine | undefined;
  /**
   * The ID of the prompt template to update
   */
  id: string;
  /**
   * The kind of prompt the template is used for
   */
  kind?: UpdatePromptTemplateFormKind | undefined;
  /**
   * The name of the prompt template. Will be updated via variation
   */
  name?: string | undefined;
  /**
   * The template content
   */
  prompt?: string | undefined;
  /**
   * The suggested tool URNS associated with the prompt template
   */
  toolUrnsHint?: Array<string> | undefined;
  /**
   * The suggested tool names associated with the prompt template
   */
  toolsHint?: Array<string> | undefined;
};

/** @internal */
export const UpdatePromptTemplateFormEngine$outboundSchema: z.ZodMiniEnum<
  typeof UpdatePromptTemplateFormEngine
> = z.enum(UpdatePromptTemplateFormEngine);

/** @internal */
export const UpdatePromptTemplateFormKind$outboundSchema: z.ZodMiniEnum<
  typeof UpdatePromptTemplateFormKind
> = z.enum(UpdatePromptTemplateFormKind);

/** @internal */
export type UpdatePromptTemplateForm$Outbound = {
  arguments?: string | undefined;
  description?: string | undefined;
  engine?: string | undefined;
  id: string;
  kind?: string | undefined;
  name?: string | undefined;
  prompt?: string | undefined;
  tool_urns_hint?: Array<string> | undefined;
  tools_hint?: Array<string> | undefined;
};

/** @internal */
export const UpdatePromptTemplateForm$outboundSchema: z.ZodMiniType<
  UpdatePromptTemplateForm$Outbound,
  UpdatePromptTemplateForm
> = z.pipe(
  z.object({
    arguments: z.optional(z.string()),
    description: z.optional(z.string()),
    engine: z.optional(UpdatePromptTemplateFormEngine$outboundSchema),
    id: z.string(),
    kind: z.optional(UpdatePromptTemplateFormKind$outboundSchema),
    name: z.optional(z.string()),
    prompt: z.optional(z.string()),
    toolUrnsHint: z.optional(z.array(z.string())),
    toolsHint: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      toolUrnsHint: "tool_urns_hint",
      toolsHint: "tools_hint",
    });
  }),
);

export function updatePromptTemplateFormToJSON(
  updatePromptTemplateForm: UpdatePromptTemplateForm,
): string {
  return JSON.stringify(
    UpdatePromptTemplateForm$outboundSchema.parse(updatePromptTemplateForm),
  );
}
